import React from 'react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './pricingprelogin.css';
import Pricing from '../pricingsection/pricingsection';
import PricingFeatureTable from '../pricing-featuretable/pricing-featuretable';
import '@fortawesome/fontawesome-free/css/all.min.css';
// import FAQ from '../pricing-FAQ/pricing-faq';
import { useState } from 'react';

const Pricingprelogin = () => {
  const location = useLocation();
  const [showFeatureTable, setShowFeatureTable] = useState(false);

  useEffect(() => {
    if (location.state?.showFeatureTable) {
      setShowFeatureTable(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.showFeatureTable) {
      setShowFeatureTable(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.showFeatureTable) {
      setShowFeatureTable(true);
    }
  }, [location.state]);

  const handleToggleFeatureTable = () => {
    setShowFeatureTable((prev) => !prev);
  };
  return (
    <div>
      <div className="fluid-container">
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <div className="pricing-page-content-wrapper">
            <div className="pricing-breadcrumb">
              <span style={{
                color: '#F35824', fontWeight: '600', textDecoration: 'none', marginRight: '50px'
              }}>
                <Link
                  to={-1}
                  style={{ textDecoration: 'none' }}
                  state={{ scrollPosition: sessionStorage.getItem("initialScrollPosition") }}
                >
                  Back
                </Link>
                <span style={{ marginLeft: '10px' }}> /</span>
                <span style={{ marginLeft: '10px' }}> Pricing</span>
              </span>
            </div>
          </div>
        </div>

        <Pricing page="pricingprelogin" className="white-background" hideTopSections={true} onToggleFeatureTable={handleToggleFeatureTable} />

        {/* {showFeatureTable && <PricingFeatureTable />}  */}
        {/* Conditional rendering */}

        {/* <FAQ /> */}
      </div>
    </div>
  );
};

export default Pricingprelogin;